module.exports = __webpack_public_path__ + "img/shaka.c7dade3d.svg";